/**
 * FERP Portal - Transaction List Page (DRR-074: Tabulator DRY Template)
 *
 * MONITOR Phase: Atomic cross-subgraph operations with ACID guarantees.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function TransactionListPage() {
  return <TabulatorPrimitiveManager primitiveType="transaction" />;
}

export default TransactionListPage;
